import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0cfcf558&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.css?vue&type=style&index=0&id=0cfcf558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcf558",
  null
  
)

export default component.exports